/*
 * @Author: showangjing showangjing@didiglobal.com
 * @Date: 2022-12-15 15:19:34
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @LastEditTime: 2023-03-12 20:10:40
 * @FilePath: /es-package/packages/es-tanker-recognizer/lib/Tanker/rules.js
 * @Description: 容器来源
 */
import { ES_WXMIN_APPID, PS_WXMIN_APPID } from './wx'

// H5
export const WEB_DEFAULT_CODE = 200000
export const WEB_DEFAULT_TANKER = 'web'
// 滴滴 星河小程序
export const DD_MINI_DEFAULT_CODE = 200010
export const DD_MINI_TANKER = 'dd'
// 企业级H5
export const DD_ES_DEFAULT_CODE = 200020
// 微信（不包含企业微信）
export const DD_WX_DEFAULT_CODE = 200030
// 滴滴出行 微信小程序
export const DD_WX_CHUXING_MINIPROGRAM_DEFAULT_CODE = 200031
// 滴滴企业版 微信小程序
export const DD_WX_ES_MINIPROGRAM_DEFAULT_CODE = 200032
// 其他 微信小程序
export const DD_WX_MINIPROGRAM_DEFAULT_CODE = 200033
// 企业微信
export const DD_WXWORK_DEFAULT_CODE = 200040
// 飞书
export const DD_FEISHU_DEFAULT_CODE = 200050
// 钉钉
export const DD_DINGTALK_DEFAULT_CODE = 200060
// 浏览器 pc passport
export const WEB_PC_PASSPORT_CODE = 200070
// 代客下单
export const SERVICE_ORDER_CODE = 10001

export const TankerRules = [
  // 企业级H5
  {
    app: 'didies',
    rules: ['didies'],
    code: DD_ES_DEFAULT_CODE
  },
  // 微信（不包含企业微信）
  {
    app: 'wx',
    rules: ['micromessenger', ['-', 'wxwork']],
    code: DD_WX_DEFAULT_CODE,
    subterms: [
      {
        app: 'mini',
        rules: [`miniprogram/${PS_WXMIN_APPID}`],
        weight: 1
      },
      {
        app: 'mini',
        rules: [`miniprogram/${ES_WXMIN_APPID}`],
        weight: 2
      },
      {
        app: 'mini',
        rules: ['miniprogram'],
        weight: 3
      }
    ]
  },
  // 企业微信
  {
    app: 'wxwork',
    rules: ['wxwork'],
    code: DD_WXWORK_DEFAULT_CODE,
    subterms: [
      {
        app: 'mini',
        rules: ['miniprogram'],
        weight: 1
      }
    ]
  },
  // 飞书
  {
    app: 'feishu',
    rules: ['feishu'],
    code: DD_FEISHU_DEFAULT_CODE
  },
  // 钉钉
  {
    app: 'dingtalk',
    rules: ['aliapp\\(dingtalk'],
    code: DD_DINGTALK_DEFAULT_CODE
  }
]
